import { AxiosResponse } from 'axios';
import { api } from '../api';
import { StandardResponse } from '../interfaces/Common';
import { User, UserProfile } from '../interfaces/User';

export async function updateProfile(user: User): Promise<StandardResponse<User>> {
    const response: AxiosResponse<StandardResponse<User>> = await api.post("/profile", user);
    return response.data;
}

export async function profile(): Promise<StandardResponse<UserProfile>> {
    const response: AxiosResponse<StandardResponse<UserProfile>> = await api.get("/profile");
    return response.data;
}